import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { Box, Button as CoreButton } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
var List = styled(Box).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    as: 'ul',
    $styles: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto'
    }
  };
}).withConfig({
  displayName: "CtaNavigation__List",
  componentId: "sc-1j2vaed-0"
})([""]);
List.displayName = 'CtaNavigation.List';
var ListItem = styled.li.withConfig({
  displayName: "CtaNavigation__ListItem",
  componentId: "sc-1j2vaed-1"
})(["", " &:last-child{margin-right:0;}"], function (props) {
  return props.theme.normalizeStyles({
    marginRight: props.theme.header.ctaNavigation.gutter
  });
});
ListItem.displayName = 'CtaNavigation.ListItem';
var Button = styled(CoreButton).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['needReferer'].includes(prop);
  }
}).attrs(function (_ref2) {
  var theme = _ref2.theme,
      $isMobileButton = _ref2.$isMobileButton,
      _ref2$needReferer = _ref2.needReferer,
      needReferer = _ref2$needReferer === void 0 ? false : _ref2$needReferer;
  return {
    rel: needReferer ? 'strict-origin-when-cross-origin' : 'no-referrer',
    $buttonType: $isMobileButton ? theme.header.ctaNavigation.mobileButton.type : theme.header.ctaNavigation.button.type,
    $withArrow: true,
    $styles: $isMobileButton ? _objectSpread(_objectSpread({}, theme.header.ctaNavigation.mobileButton.size), {}, {
      '.focus-trap': _objectSpread({}, theme.header.ctaNavigation.mobileButton.spacing)
    }) : _objectSpread(_objectSpread({
      display: 'block'
    }, theme.header.ctaNavigation.button.size), {}, {
      '.focus-trap': _objectSpread({}, theme.header.ctaNavigation.button.spacing)
    })
  };
}).withConfig({
  displayName: "CtaNavigation__Button",
  componentId: "sc-1j2vaed-2"
})([""]);

var CtaNavigation = function CtaNavigation(props) {
  return /*#__PURE__*/_jsx(List, {
    children: React.Children.map(props.children, function (c, i) {
      return /*#__PURE__*/_jsx(ListItem, {
        children: c
      }, i);
    })
  });
};

export default Object.assign(CtaNavigation, {
  Button: Button
});